"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlMonthPicker", function ($timeout, keyCodes) {
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: require("./tl-month-picker.html"),
    controllerAs: "$monthPicker",
    require: ["tlMonthPicker", "ngModel"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        ngModelCtrl = controllers[1];
      ctrl.initialize(ngModelCtrl);
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        dropdownEl = $element.find(".tl-month-picker-dropdown"),
        ngModelCtrl = null,
        focusOutPromise = null;
      ctrl.state = {
        focused: false,
        opened: false,
        selectedMonth: null,
        selectedYear: null
      };
      ctrl.initialize = function (_modelCtrl) {
        ngModelCtrl = _modelCtrl;
        generateSelectOptions();
        bindDomEvents();
        wireToModel();
      };
      ctrl.toggleDropdown = function () {
        if (ctrl.state.opened) {
          ctrl.closeDropdown();
        } else {
          ctrl.openDropdown();
        }
      };
      ctrl.openDropdown = function () {
        if (ctrl.state.opened === true) {
          return;
        }
        dropdownEl.show().appendTo(document.body);
        dropdownEl.position({
          my: "left top",
          at: "left bottom+0px",
          of: $element,
          collision: "flip",
          within: document.body
        });
        ctrl.state.opened = true;
      };
      ctrl.closeDropdown = function () {
        if (ctrl.state.opened === false) {
          return;
        }
        dropdownEl.hide().appendTo($element);
        dropdownEl.css({
          top: "",
          left: "",
          bottom: "",
          right: ""
        });
        ctrl.state.opened = false;
      };
      ctrl.validateDate = function () {
        syncValueToModel();
        ctrl.closeDropdown();
      };
      var modelUnwatch = null;
      var wireToModel = function wireToModel() {
        if (modelUnwatch != null) {
          modelUnwatch();
        }
        modelUnwatch = $scope.$watch(function () {
          return ngModelCtrl.$modelValue;
        }, applyModelValue);
      };
      function bindDomEvents() {
        var selectAndDropdown = $element.add(dropdownEl);
        var openedByFocus = false;

        // click on collapsed select
        $element.find(".tl-month-picker-input").click(function (e) {
          if (openedByFocus) {
            openedByFocus = false;
            return;
          }
          ctrl.toggleDropdown();
          $scope.$apply();
        });
        selectAndDropdown.bind("focusin", function (e) {
          cancelFocusOut();
          ctrl.state.focused = true;
          ctrl.openDropdown();
          openedByFocus = true;
          $scope.$apply();
        });
        selectAndDropdown.bind("focusout", function (e) {
          cancelFocusOut();
          focusOutPromise = $timeout(function () {
            $scope.$apply(function () {
              if (!ctrl.state.focused) {
                return;
              }
              if (focusIsInsideWidget()) {
                return;
              }
              ctrl.closeDropdown();
              ctrl.state.focused = false;
              focusOutPromise = null;
              openedByFocus = false;
            });
          }, 50, false);
        });
        selectAndDropdown.keydown(function (e) {
          switch (e.which) {
            case keyCodes.ESCAPE:
              e.preventDefault();
              ctrl.closeDropdown();
              $scope.$apply();
              break;
          }
        });
      }
      function generateSelectOptions() {
        // months
        var monthOptions = [];
        _.times(12, function (i) {
          var label = moment().month(i).format("MMMM");
          monthOptions.push({
            month: i,
            label: label
          });
        });
        $scope.monthOptions = monthOptions;

        // years
        var currentYear = moment().year();
        var yearOptions = [];
        for (var i = currentYear - 20; i < currentYear + 10; i++) {
          yearOptions.push({
            year: i,
            label: i
          });
        }
        $scope.yearOptions = yearOptions;
      }
      function applyModelValue() {
        ctrl.modelValue = ngModelCtrl.$modelValue;
        ctrl.state.selectedMonth = moment(ctrl.modelValue).month();
        ctrl.state.selectedYear = moment(ctrl.modelValue).year();
      }
      function syncValueToModel() {
        var newDate = moment().year(ctrl.state.selectedYear).month(ctrl.state.selectedMonth).startOf("day").toDate();
        if (moment(newDate).isSame(ngModelCtrl.$modelValue, "month")) {
          return;
        }
        ngModelCtrl.$setViewValue(newDate);
        ngModelCtrl.$commitViewValue();
        $element.trigger("change", {
          value: newDate
        });
      }
      function focusIsInsideWidget() {
        var focusParents = $(document.activeElement).parents().addBack();
        return focusParents.index($element) > -1 || focusParents.index(dropdownEl) > -1;
      }
      function cancelFocusOut() {
        if (focusOutPromise != null) {
          $timeout.cancel(focusOutPromise);
          focusOutPromise = null;
        }
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-month-picker.js
// module id = 2975
// module chunks = 13